import { render } from "./GenmanipulatedSubstances.vue?vue&type=template&id=29c95892&scoped=true"
import script from "./GenmanipulatedSubstances.vue?vue&type=script&lang=js"
export * from "./GenmanipulatedSubstances.vue?vue&type=script&lang=js"

import "./GenmanipulatedSubstances.vue?vue&type=style&index=0&id=29c95892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c95892"]])

export default __exports__